import React, { useState } from "react";
import Modal from "components/BaseWidgets/modal";
import Button from "components/BaseWidgets/button";
import RadioButton from "components/BaseWidgets/radioButton";

const reportReasons = [
  "Safety & Security Concerns",
  "Authenticity & Misrepresentation",
  "Behavioral Issues",
  "Personal Boundaries",
  "Platform Policy Violations",
];

const ReportProfileModal = ({
  isOpen,
  onCancel,
  onConfirm,
  title = "Report this profile",
  confirmText = "Report",
  cancelText = "Cancel",
  confirmVariant = "primary",
}) => {
  const [selectedReason, setSelectedReason] = useState("");

  const reportReasonOptions = reportReasons.map((reason) => ({
    label: reason,
    value: reason,
  }));

  const handleConfirm = () => {
    if (selectedReason) {
      onConfirm(selectedReason);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onCancel={onCancel}
      onOk={handleConfirm}
      title={title}
      footer={null}
      closable={false}
      width={440}
    >
      <p className="font-body-normal mb-3">
        Why are you reporting this profile?
      </p>

      <RadioButton
        options={reportReasonOptions}
        value={selectedReason}
        onChange={(e) => setSelectedReason(e.target.value)}
        variant="secondary"
        className="flex flex-col gap-2"
      />

      <div className="flex justify-end gap-2 mt-5">
        <Button
          className="modal-buttons"
          variant="secondary"
          height={44}
          onClick={onCancel}
        >
          {cancelText}
        </Button>
        <Button
          className="modal-buttons"
          variant={confirmVariant}
          onClick={handleConfirm}
          disabled={!selectedReason}
        >
          {confirmText}
        </Button>
      </div>
    </Modal>
  );
};

export default ReportProfileModal;
